import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IntuitiveIndication } from '../../models';
import { ToothModalResult } from '../../models/tooth-modal';

/**
 * Interface implemented by context-specific indication services.
 * Strategies depend on this interface, never on concrete facades.
 */
export interface IndicationOperations {
	/**
	 * Assigns the given indication to the currently selected teeth.
	 * When `skipResetTooth` is true, only the UnitTypeID is updated (used before opening a modal
	 * so that a cancel leaves teeth values intact).
	 */
	assignIndication(indicationId: IntuitiveIndication, skipResetTooth?: boolean): void;

	/**
	 * Opens the modal dialog appropriate for the given indication, if one is needed.
	 * Returns null when no modal is required for this indication.
	 */
	openModalForUnitTypeIfNeeded(indicationId: IntuitiveIndication): Observable<ToothModalResult> | null;
}

export const INDICATION_OPERATIONS = new InjectionToken<IndicationOperations>('INDICATION_OPERATIONS');
